module.exports = __webpack_public_path__ + "img/header_bg.393bad5.webp";